import { SelectListOption } from "@shared/components/form-fields/select-list-option";

export class EnumUtil {

  public static getEnumValueByKey(enumObj: Record<string, string>, enumKey: string): string {
    return enumObj[enumKey];
  }

  public static getEnumKeyByValue(enumObj: Record<string, number | string>, enumValue: number | string): string | undefined {
    return Object.keys(enumObj).find((key) => enumObj[key] == enumValue);
  }

  public static getSelectListOptionsFromStringEnum(enumObj: {[s: string]: string}): SelectListOption[] {
    return Object.values(enumObj).map(v => ({value:v, label:v}));
  }

}
